const researches = [
    {
        title: 'Enhancing Software Processes through Data Science',
        description: 'We explore the intersection of data science and software engineering to significantly enhance software development processes. By applying advanced data analytics, machine learning, and big data technologies, we aim to uncover insights that lead to more efficient, effective, and reliable software development practices. Through these studies, we demonstrate how data-driven approaches can optimize decision-making, improve software quality, and increase the productivity of development teams by providing actionable insights derived from vast amounts of software project data.',
        selectedPublications: [
            {
                authors: 'Emre Sülün, Metehan Saçakcı, and Eray Tüzün',
                title: 'An Empirical Analysis of Issue Templates Usage in Large-Scale Projects on GitHub',
                venue: 'ACM Transactions on Software Engineering and Methodology',
                date: 'Jan 2024'
            },
            {
                authors: 'Çağrı Eren, Kerem Şahin, and Eray Tüzün',
                title: 'Analyzing Bug Life Cycles to Derive Practical Insights',
                venue: '27th  International Conference on Evaluation and Assessment in Software Engineering - Best Paper Award',
                date: 'June 2022'
            },
            {
                authors: 'Ziya Mukhtarov, Mannan Abdul, Mokhlaroyim Raupova, Javid Baghirov, Osama Tanveer, Haluk Altunel and Eray Tüzün',
                title: 'Towards Better Code Reviews: Using Mutation Testing to Improve Reviewer Attention',
                venue: '17th International Conference on Software and System Processes - Best Paper Award',
                date: 'Jan 2024'
            },
        ]
    },
    {
        title: 'Assessment and Improvement of Process Smells in Software Development',
        description: 'Our research in this area focuses on identifying, classifying, and mitigating process smells within software development environments. Process smells, akin to code smells, are indicators of potential inefficiencies or problems in software development workflows that, if addressed, can significantly enhance the quality and speed of software production. Through empirical analysis and the development of taxonomies for inline comments and bug-tracking process smells, we provide practitioners with a deeper understanding of these inefficiencies. Our goal is to offer actionable strategies for software teams to improve their development processes, thereby leading to more effective project management and enhanced software quality.',
        selectedPublications: [
            {
                authors: 'Elgun Jabrayilzade, Ayda Yurtoğlu, and Eray Tüzün',
                title: 'Taxonomy of Inline Comments',
                venue: 'Empirical Software Engineering',
                date: 'December 2023'
            },
            {
                authors: 'Khushbakht Ali Qamar, Emre Sulun, Eray Tuzun',
                title: 'Taxonomy of Bug Tracking Process Smells Perceptions of practitioners and an empirical analysis',
                venue: 'Information and Software Technology',
                date: 'May 2022'
            },
            {
                authors: 'Erdem Tuna, Vladimir Kovalenko, Eray Tüzün',
                title: 'Bug Tracking Process Smells in Practice',
                venue: 'International Conference on Software Engineering 2022, in Practice',
                date: 'May 2022'
            },
            {
                authors: 'Emre Dogan and Eray Tüzün',
                title: 'Towards a Taxonomy of Code Review Smells: A Quantitative Analysis',
                venue: 'Information and Software Technology',
                date: '2021'
            },
            {
                authors: 'Erdem Tuna, Carolyn Seaman and Eray Tüzün',
                title: 'Do Code Reviews Lead to Fewer Code Smells?',
                venue: 'Information and Software Technology',
                date: '2024'
            },
            {
                authors: 'Furkan Gon, Burak Yetistiren, and Eray Tüzün',
                title: 'Towards Unmasking LGTM Smells in Code Reviews: A Comparative Study of Comment-Free and Commented Reviews',
                venue: '40th IEEE International Conference on Software Maintenance and Evolution',
                date: '2024'
            },
            
        ],
    },
    {
        title: 'Validity and Reliability of Ground Truth in Software Engineering Research',
        description: 'This area of research scrutinizes the foundation upon which software engineering research is often built—the ground truth data used in empirical studies, particularly in code reviewer recommendations and bug-tracking systems. We challenge the accuracy and reliability of these foundational datasets, highlighting the potential for biases and inaccuracies that can significantly impact the outcomes of research studies. By investigating the validity of ground truth in software engineering and applying blockchain technology to improve process integrity, our work calls for a critical examination of empirical data sources. We aim to establish methodologies that ensure the robustness and reliability of ground truth data, thereby enhancing the credibility and generalizability of research findings in software engineering.',
        selectedPublications: [
            {
                authors: 'Eray Tüzün, Hakan Erdogmus, M. Teresa Baldassarre, Michael Felderer, Robert Feldt and Burak Turhan',
                title: 'Ground-Truth Deficiencies in Software Engineering: When Codifying the Past Can Be Counterproductive',
                venue: 'IEEE Software',
                date: 'May-June 2022'
            },
            {
                authors: 'K. Ayberk Tecimer, Eray Tüzün, Cansu Moran, and Hakan Erdogmus',
                title: 'Cleaning Ground Truth Data in Software Task Assignment',
                venue: 'Information Software and Technology',
                date: 'September 2022'
            },
            {
                authors: 'Emre Dogan, Eray Tuzun, Ayberk Tecimer, H. Altay Guvenir,',
                title: 'Investigating the Validity of Ground Truth in Code Reviewer Recommendation Studies',
                venue: 'Empirical Software Engineering and Measurement (ESEM) 2019 – Best Paper award',
                date: 'September 2019'
            },
        ],
    },
    {
        title: 'Leveraging Artifact Traceability for Enhanced Software Engineering Practices',
        description: 'In this research stream, we delve into the utilization of artifact traceability graphs as a means to improve various aspects of software engineering practices, from reviewer recommendations to the identification of key developers. Artifact traceability, the ability to link and follow the life of software artifacts across the development lifecycle, presents a rich opportunity to enhance collaboration, quality assurance, and project management. Our studies demonstrate how traceability graphs can be employed to provide insights into developer contributions, facilitate more effective code reviews, and support the management of development processes. By advancing the methods and tools for leveraging artifact traceability, we contribute to the development of more coherent, efficient, and manageable software engineering projects.',
        selectedPublications: [
            {
                authors: 'Vahid Haratian, Mikhail Evtikhiev, Pouria Derakhshanfar, Eray Tüzün, Vladimir Kovalenko',
                title: 'BFSig: Leveraging File Significance in Bus Factor Estimation',
                venue: '31st ACM Joint European Software Engineering Conference and Symposium on the Foundations of Software Engineering',
                date: 'Dec 2023'
            },
            {
                authors: 'Egor Klimov, Muhammad Umair Ahmed, Nikolai Sviridov, Pouria Derakhshanfar, Eray Tüzün, Vladimir Kovalenko',
                title: 'Bus Factor Explorer',
                venue: '38th IEEE/ACM International Conference on Automated Software Engineering',
                date: 'September 2023'
            },
            {
                authors: 'Elgun Jabrayilzade, Mikhail Evtikhiev, Eray Tüzün, Vladimir Kovalenko',
                title: 'Bus Factor in Practice',
                venue: 'International Conference on Software Engineering, Practice Track',
                date: 'May 2022'
            },
            {
                authors: 'H. Alperen Çetin, Eray Tüzün',
                title: 'Analyzing Developer Contributions using Artifact Traceability Graphs',
                venue: 'Empirical Software Engineering',
                date: 'March 2022'
            },
            {
                authors: 'Emre Sülün, Uğur Doğrusöz, Eray Tüzün',
                title: 'RSTrace+: Reviewer Suggestion using Software Artifact Traceability Graphs',
                venue: 'Information and Software Technology',
                date: 'May 2022'
            },
        ],
    },
];

export default researches;